import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants,
} = segment;

const trackBlockVisibilityChanged = ({
  blockId,
  breakpointType,
  isHidden,
  triggerId,
  isWidget = false,
}) => {
  const blockEvent = isHidden ? constants.events.BLOCK_HIDDEN : constants.events.BLOCK_SHOWN;
  const widgetEvent = isHidden ? constants.events.WIDGET_HIDDEN : constants.events.WIDGET_SHOWN;

  trackEvent(isWidget ? widgetEvent : blockEvent, {
    blockId,
    breakpointType,
    triggerId,
  });
};

export default trackBlockVisibilityChanged;
